import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Card } from 'reactstrap'
import Box from '@material-ui/core/Box'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { withStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Typography } from '@material-ui/core'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Data from './Data'
import * as d3 from 'd3'
import * as _ from 'lodash'
import Autosuggest from 'react-autosuggest'

import { DISTRO_VIEW, NETWORK_VIEW, GENRE_VIEW, PLAN_VIEW, CUSTOM_VIEW, BROADCAST_VIEW, OTHER_CATEGORIES, OTHER, DISTRO_VIEW_STREAMING, DISTRO_VIEW_CABLE, DISTRO_VIEW_BROADCAST, DISTRO_VIEW_MOVIE, DISTRO_VIEW_MOVIES, DISTRO_VIEW_PREMIUM,
  DISTRO_VIEW_SPORTS, NETWORK_VIEW_NETFLIX, NETWORK_VIEW_HULU, NETWORK_VIEW_HBO_MAX, NETWORK_VIEW_AMAZON, NETWORK_VIEW_DISNEY_PLUS,
  NETWORK_VIEW_PEACOCK, NETWORK_VIEW_APPLE_TV_PLUS, BROADCAST_VIEW_ABC, BROADCAST_VIEW_CBS, BROADCAST_VIEW_NBC, BROADCAST_VIEW_FOX,
  BROADCAST_VIEW_CW, BROADCAST_VIEW_Cable, PLAN_VIEW_PLAN } from '../../constants/commons'

const styles = () => ({
  bigIndicator: {
    height: 1,
    backgroundColor: '#0090A7'
  }
})

class Dashboard extends React.Component {
  static propTypes = {
    fetchuMapTopicPlan: PropTypes.func.isRequired,
    fetchuMapGenreDemo: PropTypes.func.isRequired,
    setUMapSelectedTopic: PropTypes.func.isRequired,
    genreDemoSummary: PropTypes.object,
    plan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      currentPage: PropTypes.number.isRequired,
      endOfResult: PropTypes.bool.isRequired,
      planFilters: PropTypes.object.isRequired,
      details: PropTypes.object
    }).isRequired,
    selectedTopic: PropTypes.string
  }

  constructor (props){
    super(props)
    this.state = {
      entities: [],
      status: 'init',
      topicNameSuggestions: [],
      populateSelectedTopicName: {},
      topicNameValue: '',
      setUMapSelectedTopic: this.props.setUMapSelectedTopic || '',
      selectedPoints: [],
      selectedPointsByCount: [],
      annotationCount: 0,
      selectedTab: DISTRO_VIEW,
      top5genres: [],
      customEntities: [],
      value: 0,
      screenWidth: window.innerWidth,
      distributionList: [],
      networkList: [],
      genreList: []
    }
  }

  componentDidMount () {
    this.loadEntities ()
    window.addEventListener('resize', this.updateDimensions)
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.selectedTab !== this.state.selectedTab) {
      this.loadEntities ()
    }
    if (prevState.selectedPoints !== this.state.selectedPoints) {
      let catGroups = []
      let networkGroups = []
      let genreGroups = []
      let percentage = 0
      let categoriesGroup = this.state.selectedPoints.map(item => ({ id: item.id, name: item.name, category: this.checkOtherCategory(item.category), network: item.network, genre: item.genre }))
      let catGroup = _.countBy(categoriesGroup.map(e => e.category))
      let networkGroup = _.countBy(categoriesGroup.map(e => e.network))
      let genreGroup = _.countBy(categoriesGroup.map(e => e.genre))
      Object.keys(catGroup).forEach(key => {
        percentage = (catGroup[key] / this.state.selectedPoints.length) * 100
        catGroups.push({
          category: key,
          count: catGroup[key],
          percentage: percentage >= 1 ? percentage.toFixed(1) : percentage.toFixed(2)
        })
      })
      catGroups = catGroups.sort((a, b) => b.percentage - a.percentage).slice(0, 5)

      Object.keys(networkGroup).forEach(key => {
        percentage = (networkGroup[key] / this.state.selectedPoints.length) * 100
        networkGroups.push({
          network: key,
          count: networkGroup[key],
          percentage: percentage >= 1 ? percentage.toFixed(1) : percentage.toFixed(2)
        })
      })
      networkGroups = networkGroups.sort((a, b) => b.percentage - a.percentage).slice(0, 5)

      Object.keys(genreGroup).forEach(key => {
        percentage = (genreGroup[key] / this.state.selectedPoints.length) * 100
        genreGroups.push({
          genre: key,
          count: genreGroup[key],
          percentage: percentage >= 1 ? percentage.toFixed(1) : percentage.toFixed(2)
        })
      })
      genreGroups = genreGroups.sort((a, b) => b.percentage - a.percentage).slice(0, 5)

      this.setState({
        distributionList: catGroups,
        networkList: networkGroups,
        genreList: genreGroups
      })

      const topicIds = this.state.selectedPoints.filter(s => s.id !== OTHER).map(s => s.id)
      this.props.fetchuMapGenreDemo(topicIds)
    }
  }

  updateDimensions = () => {
    this.setState({ screenWidth: window.innerWidth })
    if (window.innerWidth <= 768) {
      this.setState({ scrollBtn: true })
    }
  }

  loadEntities () {
    let entities = []
    d3.csv('/data/projections_with_metadata_final.csv')
      .then(data => {
        data.map(d => {
          if (this.state.selectedTab === GENRE_VIEW) {
            let genres = data.map(item => ({ name: item['topline_genre'], score: item['topline_genre'] === OTHER ? 0 : parseInt(item['num_alignments'])}))
            let genreArr = _(genres)
            .groupBy('name')
            .map((g, name) => ({name, score: _.sumBy(g, 'score')})).orderBy('score', 'desc')
            .value()
            let top5genres = genreArr.slice(0, 10).map(item => item.name)
            this.setState({ top5genres: top5genres})
          } else if (this.state.selectedTab === CUSTOM_VIEW) {
            let customEntities = data.filter(item => item['Custom'] !== OTHER).map(c => c.Custom)
            this.setState({ customEntities: customEntities})
          }
          entities.push(
            {
              index: d.index,
              id: d.id,
              name: d.topicId,
              type: d.topicSubType,
              category: this.setCategory(d),
              numAlignments: Math.round(d.num_alignments),
              x: d.x,
              y: d.y,
              showTooltip: false,
              network: d.networks,
              genre: d.topline_genre
            }
          )
        })
        this.setState({ entities: entities})
        let points = entities.map(item => ({ name: item.topicId, category: this.checkOtherCategory(item.category) }))
        let pointsGroup = _.countBy(points.map(e => e.category))
        let pointsGroups = []
        let percentage = 0
        Object.keys(pointsGroup).forEach(key => {
          percentage = (pointsGroup[key] / entities.length) * 100
          pointsGroups.push({
            category: key,
            count: pointsGroup[key],
            percentage: percentage >= 1 ? percentage.toFixed(1) : percentage.toFixed(2)
          })
        })
        this.setState({ selectedPoints: entities, selectedPointsByCount: pointsGroups })
    }).catch(() => this.setState({
      status: 'error'
    }))
  }

  setCategory = (d) => {
    if (this.state.selectedTab === DISTRO_VIEW) { //Distro: Streaming, cable, broadcast, premium, movies, sports and other (podcasts)
      switch (d.network_categories) {
        case DISTRO_VIEW_CABLE:
          return DISTRO_VIEW_CABLE
        case DISTRO_VIEW_STREAMING:
          return DISTRO_VIEW_STREAMING
        case DISTRO_VIEW_BROADCAST:
          return DISTRO_VIEW_BROADCAST
        case DISTRO_VIEW_PREMIUM:
          return DISTRO_VIEW_PREMIUM
        default:
          if (d.topicSubType === DISTRO_VIEW_MOVIE) {
            return DISTRO_VIEW_MOVIES
          } else if (d.topline_genre === DISTRO_VIEW_SPORTS) {
            return DISTRO_VIEW_SPORTS
          }
          return OTHER
      }
    } else if (this.state.selectedTab === NETWORK_VIEW) { //Network: Netflix, Hulu, HBO Max and Amazon and other
      switch (d.networks) {
        case NETWORK_VIEW_NETFLIX:
          return NETWORK_VIEW_NETFLIX
        case NETWORK_VIEW_HULU:
          return NETWORK_VIEW_HULU
        case NETWORK_VIEW_HBO_MAX:
          return NETWORK_VIEW_HBO_MAX
        case NETWORK_VIEW_AMAZON:
          return NETWORK_VIEW_AMAZON
        case NETWORK_VIEW_DISNEY_PLUS:
          return NETWORK_VIEW_DISNEY_PLUS
        case NETWORK_VIEW_PEACOCK:
          return NETWORK_VIEW_PEACOCK
        case NETWORK_VIEW_APPLE_TV_PLUS:
          return NETWORK_VIEW_APPLE_TV_PLUS
        default:
          return OTHER
      }
    } else if (this.state.selectedTab === BROADCAST_VIEW) { //Broadcast: ABC/CBS/NBC/FOX/CW/Cable/Streaming/Premium/Other
      switch (d.networks) {
        case BROADCAST_VIEW_ABC:
          return BROADCAST_VIEW_ABC
        case BROADCAST_VIEW_CBS:
          return BROADCAST_VIEW_CBS
        case BROADCAST_VIEW_NBC:
          return BROADCAST_VIEW_NBC
        case BROADCAST_VIEW_FOX:
          return BROADCAST_VIEW_FOX
        case BROADCAST_VIEW_CW:
          return BROADCAST_VIEW_CW
        default:
          switch (d.network_categories) {
            case BROADCAST_VIEW_Cable:
              return BROADCAST_VIEW_Cable
            case DISTRO_VIEW_STREAMING:
              return DISTRO_VIEW_STREAMING
            case DISTRO_VIEW_PREMIUM:
              return DISTRO_VIEW_PREMIUM
            default:
              return OTHER
          }
      }
    } else if (this.state.selectedTab === GENRE_VIEW) {
      if (this.state.top5genres.indexOf(d.topline_genre) > -1 ) {
        return d.topline_genre
      } else {
        return OTHER
      }
    } else if (this.state.selectedTab === PLAN_VIEW) {
      var plan = this.props.plan.details.recommendations.filter(p => p.topic_name === d.topicId)
      if (plan && plan.length > 0) {
        if (d.id === this.props.selectedTopic) {
          return d.topicId
        } else {
          return PLAN_VIEW_PLAN
        }
      } else {
        if (d.id === this.props.selectedTopic) {
          return d.topicId
        } else {
          return OTHER
        }
      }
    } else if (this.state.selectedTab === CUSTOM_VIEW) {
      if (this.state.customEntities.indexOf(d.Custom) > -1 ) {
        return d.Custom
      } else {
        return OTHER
      }
    }
    return OTHER
  }

  checkOtherCategory = (category) => {
    let otherCategories = OTHER_CATEGORIES.split(',')
    if (otherCategories.indexOf(category) >= 0) {
      return OTHER
    }
    return category
  }

  onTopicSuggestionsClearRequested = () => {
    this.setState({ topicNameSuggestions: [] })
  }

  onTopicFetchRequested = ({ value }) => {
    const items = this.state.entities || []
    const inputValue = value.trim().toLowerCase()
    const inputLength = inputValue.length
    this.setState({ topicNameSuggestions: ((inputLength === 0) ? [] : items.filter(item =>
      item.name.toLowerCase().indexOf(inputValue) > -1))})
  }

  onTopicNameChange = (event, { newValue }) => {
    this.setState({
      topicNameValue: newValue,
      populateSelectedTopicName: newValue
    })
  }

  onTopicNamesSuggestionsClearRequested = () => {
    this.setState({ topicNameSuggestions: [] })
  }

  onUMapSelected = (data) => {
    if (data) {
      var pts = []
      data.points && data.points.forEach(d => {
        let point = this.state.entities.filter(e => e.name === d.text)
        if (point && point.length > 0) {
          pts.push(point[0])
        }
      })
      this.setState({ selectedPoints: pts })
      var points = data.points.map(item => ({ name: item.text, category: this.checkOtherCategory(item.fullData.name) }))
      var pointsGroup = _.countBy(points.map(e => e.category))
      var pointsGroups = []
      let percentage = 0
      Object.keys(pointsGroup).forEach(key => {
        percentage = (pointsGroup[key] / this.state.selectedPoints.length) * 100
        pointsGroups.push({
          category: key,
          count: pointsGroup[key],
          percentage: percentage >= 1 ? percentage.toFixed(1) : percentage.toFixed(2)
        })
      })
      this.setState({ selectedPointsByCount: pointsGroups })
    }
  }

  onUMapDeselect = () => {
    this.loadEntities()
  }

  handleSelect = (tab) => {
    this.setState({ selectedPoints: [], selectedPointsByCount: [], selectedTab: tab })
  }

  handleChange = (event, value) => {
    this.setState({ value })
  }

  render () {
    const { classes } = this.props
    const { value } = this.state
    var topicNameSelect = ''
    const selectTopicName = (val) => {
      this.setState({populateSelectedTopicName: val})
      topicNameSelect = val.name
      this.props.fetchuMapTopicPlan(val.id)
      this.props.setUMapSelectedTopic(val.id)
    }

    const getTopicNameSuggestionValue = () => {
      return topicNameSelect
    }

    const topicNameInputProps = {
      placeholder: 'Select Topic Name',
      value: this.state.topicNameValue,
      onChange: this.onTopicNameChange
    }

    const uMapCol = 12

    return (
      <>
        <Row>
          <Col xl={uMapCol} className="discoverTab">
            <Card className="wrapperCard">
              <Tabs
                classes={{ indicator: classes.bigIndicator }}
                value={value}
                onChange={this.handleChange}
                variant="scrollable"
                scrollButtons={ window.innerWidth >= 768 ? 'off' : 'on'}
                >
                <Tab label="Distribution" onClick={() => this.handleSelect(DISTRO_VIEW)} />
                <Tab label="Network" onClick={() => this.handleSelect(NETWORK_VIEW)} />
                <Tab label="Genre" onClick={() => this.handleSelect(GENRE_VIEW)} />
              </Tabs>
              <div key="tab-content">
                {value === 0 && <Box>
                  <Data
                    plan={this.props.plan}
                    selectedTopic={this.props.selectedTopic}
                    tab={DISTRO_VIEW}
                    onUMapSelected={this.onUMapSelected}
                    onUMapDeselect={this.onUMapDeselect}
                    selectedPoints={this.state.selectedPoints}
                    annotationCount={this.state.annotationCount}
                    genreDemoSummary={this.props.genreDemoSummary}
                  />
                </Box>}
                {value === 1 && <Box>
                  <Data
                    plan={this.props.plan}
                    selectedTopic={this.props.selectedTopic}
                    tab={NETWORK_VIEW}
                    onUMapSelected={this.onUMapSelected}
                    onUMapDeselect={this.onUMapDeselect}
                    selectedPoints={this.state.selectedPoints}
                    annotationCount={this.state.annotationCount}
                    genreDemoSummary={this.props.genreDemoSummary}
                  />
                </Box>}
                {value === 2 && <Box>
                  <Data
                    plan={this.props.plan}
                    selectedTopic={this.props.selectedTopic}
                    tab={GENRE_VIEW}
                    onUMapSelected={this.onUMapSelected}
                    onUMapDeselect={this.onUMapDeselect}
                    selectedPoints={this.state.selectedPoints}
                    annotationCount={this.state.annotationCount}
                    genreDemoSummary={this.props.genreDemoSummary}
                  />
                </Box>}
                {value === 3 && <Box>
                  <div>
                    { (this.state.entities && this.state.entities.length > 0) &&
                    <Autosuggest
                      suggestions={this.state.topicNameSuggestions}
                      onSuggestionsFetchRequested={this.onTopicFetchRequested}
                      onSuggestionsClearRequested={this.onTopicNamesSuggestionsClearRequested}
                      getSuggestionValue={getTopicNameSuggestionValue}
                      renderSuggestion={(suggestion) => (
                        <div>
                          <span onClick={() => selectTopicName(suggestion)}>{suggestion.name}</span>
                        </div>
                    )}
                      inputProps={topicNameInputProps}
                    />
                   }
                  </div>
                  <Data
                    plan={this.props.plan}
                    selectedTopic={this.props.selectedTopic}
                    tab={PLAN_VIEW}
                    onUMapSelected={this.onUMapSelected}
                    onUMapDeselect={this.onUMapDeselect}
                    selectedPoints={this.state.selectedPoints}
                    annotationCount={this.state.annotationCount}
                    genreDemoSummary={this.props.genreDemoSummary}
                  />
                </Box>}
              </div>
            </Card>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xl={12}>
            <Card className="bottomCard">
              <Row id='discoverRight1'>
                <DistributionView distributionList={this.state.distributionList}/>
                <NetworkView networkList={this.state.networkList}/>
                <GenreView genreList={this.state.genreList}/>
              </Row>
            </Card>
          </Col>
        </Row>
      </>
    )
  }
}

export const DistributionView = ({distributionList}) => {
  return (
    <Col xl={4} sm={12} md={6} xs={12}>
      <Box className="bottomPan">
        <Box className="d-flex align-items-center justify-content-between">
          <Box className="d-flex align-items-center">
            <Typography className="cardTitle">Distribution</Typography>
            <OverlayTrigger overlay={<Tooltip id="tooltip">Distribution</Tooltip>} placement="right">
              <img className="cardInfo" src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Box>
        </Box>
        <Typography className="cardSubTxt">Distribution method of media in view by percentage</Typography>
        <Box className="distHolder">
          <List>
            {distributionList && distributionList.map((option, index) => {
              return (
                <ListItem key={index}>
                  <Box className="d-flex align-items-center justify-content-between">
                    <Box className="optionAvatar" />
                    <Typography variant="body2" gutterBottom>{option.category}</Typography>
                  </Box>
                  <Typography variant="body2" gutterBottom className="darkTxt">{`${option.percentage}%`}</Typography>
                </ListItem>
              )
            })}
          </List>
        </Box>
      </Box>
    </Col>
  )
}

DistributionView.propTypes = {
  distributionList: PropTypes.array
}

export const NetworkView = ({networkList}) => {
  return (
    <Col xl={4} sm={12} md={6} xs={12} className="columMidle">
      <Box className="bottomPan">
        <Box className="d-flex align-items-center justify-content-between">
          <Box className="d-flex align-items-center">
            <Typography className="cardTitle">Network</Typography>
            <OverlayTrigger overlay={<Tooltip id="tooltip">Network</Tooltip>} placement="right">
              <img className="cardInfo" src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Box>
        </Box>
        <Typography className="cardSubTxt">Networks of media in view by percentage</Typography>
        <Box className="distHolder">
          <List>
            {networkList && networkList.map((option, index) => {
              return (
                <ListItem key={index}>
                  <Box className="d-flex align-items-center justify-content-between">
                    <Box className="optionAvatar" />
                    <Typography variant="body2" gutterBottom>{option.network}</Typography>
                  </Box>
                  <Typography variant="body2" gutterBottom className="darkTxt">{`${option.percentage}%`}</Typography>
                </ListItem>
              )
            })}
          </List>
        </Box>
      </Box>
    </Col>
  )
}

NetworkView.propTypes = {
  networkList: PropTypes.array
}

export const GenreView = ({genreList}) => {
  return (
    <Col xl={4} sm={12} md={6} xs={12}>
      <Box className="bottomPan">
        <Box className="d-flex align-items-center justify-content-between">
          <Box className="d-flex align-items-center">
            <Typography className="cardTitle">Genre</Typography>
            <OverlayTrigger overlay={<Tooltip id="tooltip">Genre</Tooltip>} placement="right">
              <img className="cardInfo" src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Box>
        </Box>
        <Typography className="cardSubTxt">Genre of media in view by percentage</Typography>
        <Box className="distHolder">
          <List>
            {genreList && genreList.map((option, index) => {
              return (
                <ListItem key={index}>
                  <Box className="d-flex align-items-center justify-content-between">
                    <Box className="optionAvatar" />
                    <Typography variant="body2" gutterBottom>{option.genre}</Typography>
                  </Box>
                  <Typography variant="body2" gutterBottom className="darkTxt">{`${option.percentage}%`}</Typography>
                </ListItem>
              )
            })}
          </List>
        </Box>
      </Box>
    </Col>
  )
}

GenreView.propTypes = {
  genreList: PropTypes.array
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles) (Dashboard)